import { utils } from 'components/lexemes';
import Localization, { TrustedValue } from 'lib/localization';

export default {
  tab: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.tab.title');
    },
    text() {
      return Localization.get('bumblesite@privacy.informationUsage.tab.description');
    },
    contents: {
      title() {
        return Localization.get('bumblesite@privacy.informationDisclosure.tab.contents.title');
      },
    },
  },
  section1: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section1.title');
    },
  },
  section2: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section2.title');
    },
  },
  section3: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section3.title');
    },
  },
  section4: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section4.title');
    },
  },
  section5: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section5.title');
    },
  },
  section6: {
    title() {
      return Localization.get('bumblesite@privacy.informationUsage.section6.title');
    },
    /** Numbered variant, used in the tab's list of links to topics */
    title2() {
      return Localization.get('bumblesite@privacy.informationUsage.section6.title2');
    },
  },
  lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.text1');
  },
  lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText2() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.text2', {
      terms_url: utils.getLinkMarkerUrl('terms_url'),
    });
  },
  lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText3() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.text3');
  },
  lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText4() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.text4');
  },
  lxPagePrivacyPolicyTabTwoSectionOneColumnLeftText5() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.text5');
  },
  lxPagePrivacyPolicyTabTwoSection1GoodToKnowContent() {
    return Localization.get('bumblesite@privacy.informationUsage.section1.goodToKnow.content');
  },
  lxPagePrivacyPolicyTabTwoSection2Tip() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.tip');
  },
  lxPagePrivacyPolicyTabTwoSection4GoodToKnowContent() {
    return Localization.get('bumblesite@privacy.informationUsage.section4.goodToKnow.content', {
      __EOL__: new TrustedValue('<br />'),
      link_contact_us: utils.getLinkMarkerUrl('link_our_contact_information'),
    });
  },
  lxPagePrivacyPolicyTabTwoSection4CCPATitle() {
    return Localization.get('bumblesite@privacy.informationUsage.section4.ccpa.title');
  },
  lxPagePrivacyPolicyTabTwoSection4CCPAContent({ lang }: { lang: string }) {
    return Localization.get('bumblesite@privacy.informationUsage.section4.ccpa.content', {
      link_california: `/privacy-policy/${lang || ''}#us-residents--california`,
    });
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText1() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text1');
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText2() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text2');
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText3() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text3');
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText4() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text4');
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText5() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text5');
  },
  lxPagePrivacyPolicyTabTwoSectionTwoText6() {
    return Localization.get('bumblesite@privacy.informationUsage.section2.text6');
  },
  lxPagePrivacyPolicyTabTwoSectionThreeText() {
    return Localization.get('bumblesite@privacy.informationUsage.section3.text1', {
      terms_url: utils.getLinkMarkerUrl('terms_url'),
    });
  },
  lxPagePrivacyPolicyTabTwoSectionThreeText2() {
    return Localization.get('bumblesite@privacy.informationUsage.section3.text2');
  },
  lxPagePrivacyPolicyTabTwoSectionThreeImageTipTitle() {
    return Localization.get('bumblesite@privacy.informationUsage.section3.tip.title');
  },
  lxPagePrivacyPolicyTabTwoSectionThreeImageTipContent() {
    return Localization.get('bumblesite@privacy.informationUsage.section3.tip.content', {
      terms_url: utils.getLinkMarkerUrl('terms_url'),
    });
  },
  lxPagePrivacyPolicyTabTwoSectionFourTextOne() {
    return Localization.get('bumblesite@privacy.informationUsage.section.four.text.one');
  },
  lxPagePrivacyPolicyTabTwoSectionFourTextTwo() {
    return Localization.get('bumblesite@privacy.informationUsage.section.four.text.two', {
      page_badoo_name: 'Badoo',
    });
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTextOne() {
    return Localization.get('bumblesite@privacy.informationUsage.section.five.text.one');
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTextTwo() {
    return Localization.get('bumblesite@privacy.informationUsage.section.five.text.two');
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTextThree() {
    return Localization.get('bumblesite@privacy.informationUsage.section.five.text.three');
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTextFour() {
    return Localization.get('bumblesite@privacy.informationUsage.section.five.text.four');
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTextFive() {
    return Localization.get('bumblesite@privacy.informationUsage.section.five.text.five');
  },
  /**
   * The `section.sixe.*` sysnames below contain a typo in the lexeme service.
   * Keep them as they are — that is how they are published.
   */
  lxPagePrivacyPolicyTabTwoSectionSixTextOne() {
    return Localization.get('bumblesite@privacy.informationUsage.section.sixe.text.one');
  },
  lxPagePrivacyPolicyTabTwoSectionSixTextTwo() {
    return Localization.get('bumblesite@privacy.informationUsage.section.sixe.text.two');
  },
  lxPagePrivacyPolicyTabTwoSectionSixTextThree() {
    return Localization.get('bumblesite@privacy.informationUsage.section.sixe.text.three');
  },
  lxPagePrivacyPolicyTabTwoSectionSixTextFour() {
    return Localization.get('bumblesite@privacy.informationUsage.section.sixe.text.four');
  },
  lxPagePrivacyPolicyTabTwoSectionSixTextFive() {
    return Localization.get('bumblesite@privacy.informationUsage.section.sixe.text.five');
  },
  goodToKnow() {
    return Localization.get('bumblesite@privacy.goodToKnow');
  },
  lxPagePrivacyPolicyTabTwoSectionFiveTable() {
    return [
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row1.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row1.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row1.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row2.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row2.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row2.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row2.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row3.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.item4'),
      ],
      // I had to use row1.1.itemX here to avoid adding +1
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row3.1.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.1.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row3.1.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row4.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row4.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row4.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row4.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row5.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row5.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row5.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row5.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row6.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row6.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row6.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row6.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row7.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row7.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row7.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row7.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row8.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row8.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row8.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row8.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row19.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row19.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row19.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row19.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row9.item1', {
          terms_url: utils.getLinkMarkerUrl('terms_url'),
        }),
        Localization.get('bumblesite@privacy.informationUsage.table.row9.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row9.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row9.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row10.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row10.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row10.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row10.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row11.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row11.item2', {
          link_linked_social_media_information: utils.getLinkMarkerUrl(
            'link_linked_social_media_information',
          ),
        }),
        Localization.get('bumblesite@privacy.informationUsage.table.row11.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row11.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row12.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row12.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row12.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row12.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row13.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row13.item2')
          /**
           * @TODO fix lexemes when it is ready - https://bumble.slack.com/archives/C078XLHPSP7/p1727103937764389
           */
          .replace('<br ', '<br /> '),
        Localization.get('bumblesite@privacy.informationUsage.table.row13.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row13.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row14.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row14.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row14.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row14.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row15.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row15.1.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.1.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row15.1.item4'),
      ],
      [
        `${Localization.get(
          'bumblesite@privacy.informationUsage.table.row16.item1',
        )}<div id="information-usage--lawful-basis--Processing-we-perform-to-improve-services-for-students"></div><br /><br /><br /><br /><br />`,
        Localization.get('bumblesite@privacy.informationUsage.table.row16.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row16.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row16.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row16.1.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row16.1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row16.1.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row16.1.item4'),
      ],
      [
        /**
         * This is important update for compatibility with old code - #Processing-we-perform-to-improve-services-for-students
         * to `/privacy-policy/#information-usage--lawful-basis--Processing-we-perform-to-improve-services-for-students`
         */
        Localization.get('bumblesite@privacy.informationUsage.table.row17.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row17.1.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.1.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row17.1.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row18.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row18.1.item1', {
          page_badoo_name: 'Badoo',
        }),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.1.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.1.item3', {
          page_badoo_name: 'Badoo',
        }),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.1.item4'),
      ],
      [
        Localization.get('bumblesite@privacy.informationUsage.table.row18.2.item1'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.2.item2'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.2.item3'),
        Localization.get('bumblesite@privacy.informationUsage.table.row18.2.item4'),
      ],
    ];
  },
};
